import {
  QueryConfigType,
  useQuery,
  UseQueryResult,
  ExtractFnReturnType,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsCompaniesFeatureFlagsIndexResponseType } from "~/domains";

type RequestDataType = {
  companyId: string;
};

const request = async ({
  companyId,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesFeatureFlagsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesFeatureFlagsIndexResponseType>(
      `/api/admin_operators/companies/${companyId}/feature_flags`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsCompaniesFeatureFlagsIndex = ({
  companyId,
  config = {},
}: PropsType): UseQueryResult<ExtractFnReturnType<QueryFnType>> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesFeatureFlagsIndex", companyId],
    () => request({ companyId }),
    {
      ...config,
    },
  );
};
